export const PENDING = 'PENDING';
export const COMPLETE = 'COMPLETE';
export const REJECTED = 'REJECTED';
export const CANCELLED = 'CANCELLED';
